var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, Fragment, useEffect, useMemo } from 'react';
import { PageTitle } from '@src/_metronic/layout/core';
import { KTCard } from '@src/_metronic/helpers';
import DataTable from 'react-data-table-component';
import '@src/app/styles/datatable.css';
import Select from '@src/components/Atoms/Select/Select';
import { MultiDimensionalFilter, paginationOptions, transferOptions, userInformation, RoleList, FormatYearMonthDate, DefaultAllList, } from '@src/app/helper';
import { useNavigate } from 'react-router-dom';
import { useJobTypes } from '../../JobTypePage/JobType/JobType.hooks';
import RecordContactPerson from '@src/components/molecules/Record/ContactPerson';
import RecordName from '@src/components/molecules/Record/Name';
import RecordConfirmation from '@src/components/molecules/Record/Confirmation';
import DrawerDataTable from '@src/components/molecules/Drawer/DrawerDataTable';
import WithScheduleForm from '@src/components/Atoms/Drawer/ScheduleDrawer/WithScheduleForm';
import WithScheduleActions from '@src/components/Atoms/ActionDropdown/WithScheduleActions';
import Date from '@src/components/Atoms/Date/Date';
import { useSchedule } from '../NoSchedule/NoSchedule.hooks';
import { ScheduleFilterType } from '@src/components/molecules/Schedule/NoSchedule/NoSchedule.constant';
import RecordJoblist from '@src/components/molecules/Record/JobList';
import { useSocialMedia } from '../../SocialMediaPage/SocialMedia/SocialMedia.hooks';
import { useDivisions } from '../../DivisionPage/DivisionHooks/Division.hooks';
import { useTeams } from '../../TeamPage/TeamHooks/Team.hooks';
import UpScheduleForm from '@src/components/Atoms/Drawer/ScheduleDrawer/UpScheduleForm';
import NoteScheduleForm from '@src/components/Atoms/Drawer/ScheduleDrawer/NoteScheduleForm';
import dayjs from 'dayjs';
import NotFound from '@src/components/Atoms/NotFound/NotFound';
import Loading from '@src/components/Atoms/Loading/Loading';
import Input from '@src/components/Atoms/Input/Input';
//breadcrumb
var usersBreadcrumbs = [
    {
        title: 'Dengan Jadwal',
        path: '',
        isSeparator: true,
        isActive: false,
    },
];
var WithScheduleIndex = function () {
    var role = JSON.parse(userInformation).roles[0];
    var socialMedias = JSON.parse(userInformation).socialMedias;
    var socmedIds = socialMedias === null || socialMedias === void 0 ? void 0 : socialMedias.map(function (socmed) { return socmed.pubId; });
    var _a = useState(), talentRecord = _a[0], setTalentRecord = _a[1];
    var _b = useState({
        page: 1,
        pageSize: 10,
        keyword: '',
        filterBy: '[]',
        Type: ScheduleFilterType.WITHSCHEDULE,
    }), filter = _b[0], setFilter = _b[1];
    var _c = useSchedule(filter), schedules = _c.schedules, isLoading = _c.isLoading, refetchSchedule = _c.refetch;
    var syncTalentRecord = useMemo(function () {
        if (!(schedules === null || schedules === void 0 ? void 0 : schedules.data.length) || !talentRecord)
            return;
        return (schedules.data.find(function (schedule) { return schedule.talent.pubId === talentRecord.talent.pubId; }) ||
            talentRecord);
    }, [talentRecord, schedules === null || schedules === void 0 ? void 0 : schedules.data]);
    var _d = useState({
        page: 1,
        pageSize: 100,
        keyword: '',
        filterBy: '[]',
        initialFilterBy: "[[\"recordStatus\", \"Active\"]]",
    }), filterPageSize = _d[0], setFilterPageSize = _d[1];
    var _e = useState({
        page: 1,
        pageSize: 100,
        keyword: '',
        filterBy: '[]',
        initialFilterBy: "[[\"recordStatus\", \"Active\"]]",
    }), filterJobType = _e[0], setFilterJobType = _e[1];
    var _f = useJobTypes(filterJobType), jobTypes = _f.jobTypes, isLoadingJobType = _f.isLoading, refetchJobType = _f.refetch;
    var _g = useState(false), isOpenProcessSettings = _g[0], setIsOpenProcessSettings = _g[1];
    var _h = useState(false), isOpenNoteSettings = _h[0], setIsOpenNoteSettings = _h[1];
    var _j = useState(false), isOpenUpSettings = _j[0], setIsOpenUpSettings = _j[1];
    var socialMedia = useSocialMedia().socialMedia;
    var team = useTeams(filterPageSize).team;
    var divisions = useDivisions().divisions;
    if (role === RoleList.CampaignExecutive) {
        socialMedia = JSON.parse(userInformation).socialMedias;
        divisions = JSON.parse(userInformation).divisions;
        team = JSON.parse(userInformation).teams;
    }
    var getOptionTeam = function (team) {
        if (team && team.data) {
            if (team.data.length > 0) {
                return team.data.map(function (team) { return ({
                    name: team.name,
                    value: team.pubId,
                }); });
            }
            else {
                return [];
            }
        }
        else {
            if (team) {
                return team.map(function (team) { return ({
                    name: team.name,
                    value: team.pubId,
                }); });
            }
            else {
                return [];
            }
        }
    };
    var optionSocialMedia = socialMedia && socialMedia.length > 0
        ? socialMedia.map(function (social) { return ({
            name: social.name,
            value: social.pubId,
        }); })
        : undefined;
    role !== RoleList.CampaignExecutive &&
        optionSocialMedia &&
        optionSocialMedia.unshift(DefaultAllList);
    var optionDivision = divisions && divisions.length > 0
        ? role === RoleList.CampaignExecutive
            ? divisions &&
                divisions.map(function (division, index) { return ({
                    name: "".concat(division.name, " - ").concat(socialMedia && socialMedia[index].name),
                    value: division.pubId,
                }); })
            : divisions &&
                divisions.map(function (division) { return ({
                    name: "".concat(division.name, " - ").concat(division.socialMedia.name),
                    value: division.pubId,
                }); })
        : undefined;
    var optionTeam = getOptionTeam(team);
    role !== RoleList.CampaignExecutive && optionTeam && optionTeam.unshift(DefaultAllList);
    var optionJobType = jobTypes && jobTypes.data && jobTypes.data.length > 0
        ? jobTypes.data
            // .filter((obj) => socmedIds.includes(obj.socialMedia.pubId))
            .map(function (job) { return ({
            name: job.name,
            value: job.pubId,
        }); })
        : undefined;
    var _k = useState(dayjs().format('YYYY-MM-DD').toString()), date = _k[0], setDate = _k[1];
    var onChangeDate = function (e) {
        var event = { target: { name: '', value: null } };
        event.target.name = 'date';
        event.target.value = e == null ? '' : FormatYearMonthDate(e);
        setDate(event.target.value);
        handleMultiDimensionalFilterChange(event);
    };
    var handleMultiDimensionalFilterChange = function (event) {
        var filterValue = filter.filterBy !== '' ? JSON.parse(filter.filterBy) : '';
        if (filter.filterBy === '') {
            var filterCriteria = [[event.target.name, event.target.value]];
            setFilter(__assign(__assign({}, filter), { filterBy: JSON.stringify(filterCriteria) }));
        }
        else {
            var filterNew = MultiDimensionalFilter(event, filterValue);
            setFilter(__assign(__assign({}, filter), { filterBy: JSON.stringify(filterNew) }));
        }
    };
    var handleFilterChange = function (event) {
        var _a;
        setFilter(__assign(__assign({}, filter), (_a = {}, _a[event.target.name] = event.target.value, _a)));
    };
    var handlePageChange = function (page) {
        setFilter(__assign(__assign({}, filter), { page: page }));
    };
    var handlePageSizeChange = function (size) {
        setFilter(__assign(__assign({}, filter), { page: 1, pageSize: size }));
    };
    var navigate = useNavigate();
    //gotodetail
    var gotoDetail = function (record) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            navigate("/job/detail/".concat(record));
            return [2 /*return*/];
        });
    }); };
    var gotoTalent = function (record) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            navigate("/talent/detail/".concat(record));
            return [2 /*return*/];
        });
    }); };
    // TODO: show cp email and cp other and country name on datatable row, as its missing from api return
    var columns = [
        {
            name: 'Contact Person',
            cell: function (record) { return (_jsx(RecordContactPerson, { cpName: record.talent.cpName, cpPhoneNumber: record.talent.cpPhoneNumber })); },
            sortable: true,
        },
        {
            name: 'Nama',
            cell: function (record) { return (_jsx(RecordName, { pubId: record.talent.pubId, talentName: record.talent.name, profiles: record.talent.profiles })); },
            sortable: true,
        },
        {
            name: 'Kerja Sama',
            cell: function (record) { return (_jsx(RecordJoblist, { scheduleJobNumber: record.jobNumber, schedules: record.schedules })); },
            sortable: true,
        },
        {
            name: 'Oleh',
            cell: function (record) { return _jsx(RecordConfirmation, { record: record.schedules, tooltipTeam: record.team.name }); },
            sortable: true,
        },
        {
            name: 'Action',
            cell: function (record) { return (_jsx(WithScheduleActions, { handleProcess: handleProcessTalent, handleNote: handleNoteTalent, handleUp: handleUpTalent, record: record, transferType: transferOptions.pertermin })); },
        },
    ];
    var handleProcessTalent = function (record) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsOpenProcessSettings(true);
            setTalentRecord(record);
            return [2 /*return*/];
        });
    }); };
    var handleUpTalent = function (record) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsOpenUpSettings(true);
            setTalentRecord(record);
            return [2 /*return*/];
        });
    }); };
    var handleNoteTalent = function (record) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsOpenNoteSettings(true);
            setTalentRecord(record);
            return [2 /*return*/];
        });
    }); };
    // const [jobTypeValue, setJobTypeValue] = useState<number>(0)
    // const onChangeSocialMedia = (e: React.ChangeEvent<HTMLInputElement>) => {
    //   filterPageSize['filterBy'] = `[["socialMedia.pubId", "${e.target.value}"]]`
    //   setJobTypeValue(jobTypeValue + 1)
    // }
    useEffect(function () {
        var filterValue = JSON.parse(filter.filterBy);
        var filterPageSizeValue = JSON.parse(filter.filterBy);
        if (socialMedia && socialMedia.length > 0) {
            var filterCriteria = ['division.socialMedia.pubId', socialMedia && socialMedia[0].pubId];
            filterValue.push(filterCriteria);
            // let filterPageSizeCriteria = ['socialMedia.pubId', socialMedia && socialMedia[0].pubId]
            // filterPageSizeValue.push(filterPageSizeCriteria)
        }
        if (optionTeam) {
            var filterCriteria = ['team.pubId', optionTeam && optionTeam[0].value];
            filterValue.push(filterCriteria);
        }
        if (date) {
            var filterCriteria = ['date', date];
            filterValue.push(filterCriteria);
        }
        setFilter(__assign(__assign({}, filter), { filterBy: JSON.stringify(filterValue) }));
        setFilterPageSize(__assign(__assign({}, filterPageSize), { filterBy: JSON.stringify(filterPageSizeValue) }));
    }, []);
    return (_jsxs(Fragment, { children: [_jsx(PageTitle, __assign({ breadcrumbs: usersBreadcrumbs }, { children: "Dengan Jadwal" })), _jsxs(KTCard, { children: [_jsx("div", __assign({ className: 'd-flex flex-column' }, { children: _jsx("div", __assign({ className: 'card-header border-0 pt-6 d-flex flex-row' }, { children: _jsxs("div", __assign({ className: 'card-title flex' }, { children: [_jsx("div", __assign({ className: 'card-title' }, { children: _jsx(Input, { placeholder: 'Search', type: 'text', name: 'keyword', value: filter.keyword, onChange: function (e) {
                                                handleFilterChange(e);
                                            } }) })), _jsx("div", __assign({ className: 'card-title' }, { children: _jsx(Date, { date: date, handleonchange: onChangeDate }) })), _jsx("div", __assign({ className: 'card-title' }, { children: optionSocialMedia && optionSocialMedia.length > 0 && (_jsx(Select, { name: 'division.socialMedia.pubId', onChange: function (e) {
                                                handleMultiDimensionalFilterChange(e);
                                                // onChangeSocialMedia(e)
                                            }, optionList: optionSocialMedia, defaultValue: optionSocialMedia[0].value, isPlaceholder: false })) })), _jsx("div", __assign({ className: 'card-title' }, { children: optionDivision && optionDivision.length > 0 && (_jsx(Select, { name: 'division.pubId', onChange: function (e) {
                                                handleMultiDimensionalFilterChange(e);
                                            }, optionList: optionDivision, defaultValue: optionDivision[0].value })) })), _jsx("div", __assign({ className: 'card-title' }, { children: optionTeam && optionTeam.length > 0 && (_jsx(Select, { name: 'team.pubId', onChange: function (e) {
                                                handleMultiDimensionalFilterChange(e);
                                            }, optionList: optionTeam, defaultValue: optionTeam[0].value })) })), _jsx("div", __assign({ className: 'card-title' }, { children: !isLoadingJobType && optionJobType && (_jsx(Select, { name: 'jobDetail.jobType.pubId', onChange: function (e) {
                                                handleMultiDimensionalFilterChange(e);
                                            }, optionList: optionJobType })) }))] })) })) })), _jsx("div", __assign({ className: 'card-body py-4' }, { children: _jsx(DataTable, { title: ' ', columns: columns, persistTableHead: true, noDataComponent: _jsx(NotFound, {}), data: schedules ? schedules.data : [], noHeader: true, progressPending: isLoading, progressComponent: _jsx(Loading, {}), pagination: true, paginationServer: true, paginationDefaultPage: filter.page, paginationTotalRows: filter.filterBy === ''
                                ? schedules && schedules.recordsTotal
                                : schedules && schedules.recordsFiltered, paginationPerPage: filter.pageSize, paginationRowsPerPageOptions: [1, 10, 20, 30, 40, 50, 100], paginationComponentOptions: paginationOptions, onChangeRowsPerPage: handlePageSizeChange, onChangePage: handlePageChange }, schedules && schedules.data.length) }))] }), _jsx(DrawerDataTable, { isOpen: isOpenProcessSettings, handleClose: setIsOpenProcessSettings, record: syncTalentRecord, component: WithScheduleForm, size: 'LG', title: 'Detail', refetch: refetchSchedule }), _jsx(DrawerDataTable, { isOpen: isOpenUpSettings, handleClose: setIsOpenUpSettings, record: talentRecord, component: UpScheduleForm, size: 'LG', title: 'Detail', refetch: refetchSchedule }), _jsx(DrawerDataTable, { isOpen: isOpenNoteSettings, handleClose: setIsOpenNoteSettings, record: talentRecord, component: NoteScheduleForm, size: 'LG', title: 'Detail', refetch: refetchSchedule })] }));
};
export default WithScheduleIndex;
